import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonStateService {
  refreshPreOrders$ = new Subject<void>();
  refreshActiveProcesses$ = new Subject<void>();
}
